export default {
  name: 'ruleManagement',
  data () {
    /* 校验循环发送次数 */
    var cycleCountProving = (rule, value, callback) => {
      const phoneReg = /^[1-9]\d*$/
      if (this.ruleInputDisabled) {
        callback() // 循环状态否的情况可为空
      } else {
        if (!value) {
          return callback(new Error('循环状态"是"的状态下,发送次数不能为空'))
        }
      }
      setTimeout(() => {
        if (phoneReg.test(value)) {
          callback()
        } else {
          callback(new Error('发送次数格式不正确,请输入大于0的正整数'))
        }
      }, 100)
    }
    /* 校验循环间隔时间 */
    var cycleIntervalProving = (rule, value, callback) => {
      const phoneReg = /^[1-9]\d*$/
      if (this.ruleInputDisabled) {
        callback() // 循环状态否的情况可为空
      } else {
        if (!value) {
          return callback(new Error('循环状态"是"的状态下,间隔时间不能为空'))
        }
      }
      setTimeout(() => {
        if (phoneReg.test(value)) {
          callback()
        } else {
          callback(new Error('间隔时间格式不正确,请输入大于0的正整数'))
        }
      }, 100)
    }
    return {
      page: {
        num: 1,
        size: 10
      },
      totalRows: 100,
      labelPosition: 'left',
      labelPositionDialog: 'right',
      formInline: {
        ruleName: '',
        alarmType: '',
        sysId: '',
        ruleState: ''
      },
      tooltip: true,
      alermType: [],
      tableList: [],
      ruleStateData: [
        {
          id: 0,
          value: '正常'
        },
        {
          id: 1,
          value: '停止'
        },
        {
          id: 2,
          value: '测试'
        }
      ],
      dialogFormVisible: false,
      dialogTitle: {
        addRule: '新增预警规则',
        editRule: '编辑预警规则'
      },
      dialogStatus: '',
      appKeyList: [],
      startTime: '',
      endTime: '',
      ruleLabelWidth: '130px',
      ruleForm: {
        ruleId: '', // 规则id
        date: [],
        startTime: '',
        ruleName: '', // 规则名称
        ruleEnName: '', // 规则英文名称
        alarmType: '', // 预警类型(0:余额不足预警)
        ruleState: '', // 规则状态(0:正常 1:停止 2:测试)
        alarmChannel: ['0'], // 预警渠道(0:短信)
        alarmTime: '',
        appKey: [],
        sysId: '',
        cycleFlag: '0', // 是否循环(0否1是)
        cycleCount: '', // 循环发送次数
        cycleInterval: '', // 循环时间间隔
        alarmobjectIds: [], // 预警对象id集合
        templateId: '', // 模板id
        ruleDesc: '', // 规则描述
        alarmDesc: '' // 存放预警内容描述
      },
      alarmChannelData: [
        {
          id: '0',
          name: '短信'
        },
        {
          id: '1',
          name: '邮箱'
        },
        {
          id: '2',
          name: '内部通知'
        },
        {
          id: '3',
          name: '微信公众号'
        }
      ],
      typeData: [],
      templateData: [], // 信息模板
      ruleInputDisabled: true, // 循环次数和间隔时间可输入状态
      alarmobjectData: [], // 预警对象列表
      rules: {
        ruleName: [
          { required: true, message: '请输入规则名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择预警日期', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '请选择预警时间', trigger: 'blur' }
        ],
        sysId: [
          { required: true, message: '请选择业务系统', trigger: 'change' }
        ],
        ruleEnName: [
          { required: true, message: '请输入规则英文名称', trigger: 'blur' }
        ],
        ruleState: [
          { required: true, message: '请选择规则状态', trigger: 'blur' }
        ],
        alarmType: [
          { required: true, message: '请选择预警类型', trigger: 'blur' }
        ],
        alarmChannel: [
          { required: true, message: '请选择预警渠道', trigger: 'blur' }
        ],
        alarmobjectIds: [
          { required: true, message: '请选择预警对象', trigger: 'blur' }
        ],
        templateId: [
          { required: true, message: '请选择信息模板', trigger: 'blur' }
        ],
        // alarmTime: [
        //   { required: true, message: '请选择预警时间', trigger: 'blur' }
        // ],
        cycleCount: [{ validator: cycleCountProving, trigger: 'change' }],
        cycleInterval: [{ validator: cycleIntervalProving, trigger: 'change' }]
      }
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    // this.queryAlermType()
    this.queryList()
    this.queryTemplate()
    // this.queryAlarmobjects()
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    /* 规则状态转换 */
    ruleStateSwitch (row) {
      if (row.ruleState === '0') {
        return '正常'
      } else if (row.ruleState === '1') {
        return '停止'
      } else if (row.ruleState === '2') {
        return '测试'
      } else {
        return ''
      }
    },
    /* 预警发送方式转换 */
    alarmChannelSwitch (row) {
      let arr = row.alarmChannel.split(',')
      let str = ''
      if (arr.length) {
        for (let v of arr) {
          if (v === '0') {
            str += ' 短信'
          }
          if (v === '1') {
            str += ' 邮箱'
          }
          if (v === '2') {
            str += ' 内部通知'
          }
          if (v === '3') {
            str += ' 微信公众号'
          }
        }
      }
      return str
      // if (row.alarmChannel === '0') {
      //   return '短信'
      // } else if (row.alarmChannel === '1') {
      //   return '邮箱'
      // } else if (row.alarmChannel === '2') {
      //   return ''
      // } else if (row.alarmChannel === '0,1') {
      //   return '短信,邮箱'
      // } else if (row.alarmChannel === '0,2') {
      //   return '短信,内部通知'
      // } else if (row.alarmChannel === '1,2') {
      //   return '邮箱,内部通知'
      // } else if (row.alarmChannel === '0,1,2') {
      //   return '短信,邮箱,内部通知'
      // } else {
      //   return ''
      // }
    },
    /* 查询信息模板列表 */
    queryTemplate () {
      let _self = this
      /* 查询预警规则列表 */
      this.$axios
        .get(this.$API.warning.queryAllSmsTemplate, {})
        .then(function (r) {
          _self.templateData = r.data.resData.templateList
        })
        .catch(function (error) {})
    },
    /* 选择信息模板联动预警内容 */
    changeTemplate (data) {
      this.ruleForm.alarmDesc = data.templateContent
    },
    /* 如果信息模板没有选中清空预警内容描述 */
    clearRuleSel (data) {
      data === '' ? (this.ruleForm.alarmDesc = '') : ''
    },
    /* 循环状态联动循环发送次数和循环间隔时间 */
    clearRuleSelLoop (data) {
      if (data === '1') {
        this.ruleInputDisabled = false
        this.ruleForm.cycleCount = ''
        this.ruleForm.cycleInterval = ''
      } else if (data === '0') {
        this.ruleInputDisabled = true
        this.ruleForm.cycleCount = ''
        this.ruleForm.cycleInterval = ''
      }
    },
    /* 查询预警类型 */
    queryAlermType (val) {
      let _self = this
      let op = {}
      let sysIds = []
      if (val && val !== 0) {
        sysIds.push(val)
      }
      op.sysIds = sysIds
      this.$axios
        // .get(this.$API.warning.queryAllAlarmType, {})
        // .post('http://172.16.9.104:5010/agw/alarmTypeCtr/queryAllAlarmTypeBySysIds', op)
        .post(this.$API.product.queryAllAlarmTypeBySysIds, op)
        .then(function (r) {
          _self.alermType = r.data.resData.alarmObjectList
        })
        .catch(function (error) {})
    },
    sysAlermType (val) {
      let _self = this
      let op = {}

      let sysIds = []
      if (val && val !== 0) {
        sysIds.push(val)
      }
      
      op.sysIds = sysIds
      this.$axios
        // .get(this.$API.warning.queryAllAlarmType, {})
        // .post('http://172.16.9.104:5010/agw/alarmTypeCtr/queryAllAlarmTypeBySysIds', op)
        .post(this.$API.product.queryAllAlarmTypeBySysIds, op)
        .then(function (r) {
          _self.typeData = r.data.resData.alarmObjectList
        })
        .catch(function (error) {})
    },
    sChange (val) {
      this.formInline.alarmType = ''
      if (val) {
        this.sysAlermType(val)
      } else {
        this.typeData = []
      }
    },
    sysChange (val) {
      this.ruleForm.alarmType = ''
      this.ruleForm.alarmobjectIds = []
      if (val) {
        this.queryAlarmobjects(val, this.ruleForm.appKey)
        this.queryAlermType(val)
      } else {
        if (this.ruleForm.appKey) {
          this.queryAlarmobjects('', this.ruleForm.appKey)
        } else {
          this.alarmobjectData = []
        }
        this.alermType = []
      }
    },
    keyChange (val) {
      this.ruleForm.alarmobjectIds = []
      if (val) {
        this.queryAlarmobjects(this.ruleForm.sysId, val)
      } else {
        if (this.ruleForm.sysId) {
          this.queryAlarmobjects(this.ruleForm.sysId, '')
        } else {
          this.alarmobjectData = []
        }
        this.alermType = []
      }
    },
    /* 查询预警对象列表 */
    queryAlarmobjects (id, appKey) {
      let _self = this
      let op = {}
      op.sysId = id
      op.appKey = appKey
      console.log(op)
      this.$axios
        .post(this.$API.warning.queryAllAlarmObject, op)
        // .post('http://172.16.9.104:5010/agw/alarmObjectCtr/queryAlarmObjectListById', op)
        .then(function (r) {
          _self.alarmobjectData = r.data.resData.alarmObjectList
        })
        .catch(function (error) {})
    },
    /* 查询预警规则列表 */
    queryList () {
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size,
        sysIds: sysIds,
        alarmType: this.formInline.alarmType,
        ruleName: this.formInline.ruleName,
        ruleState: this.formInline.ruleState
      }
      let _self = this
      this.$axios
        .post(this.$API.warning.queryAlarmRuleListByPage, params)
        // .post('http://172.16.9.104:5010/agw/alarmRuleCtr/queryAlarmRuleListByPage', params)
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 新增 */
    handleAdd () {
      this.dialogFormVisible = true
      let op = {}
      op.appOwner = 1
      let _this = this
      this.$http
        .post(_this.$API.pay.queryAllAppInfo, {}, { headers: op })
        .then(function(r) {
          console.log(r)
          _this.appKeyList = r.data.resData
        })
        .catch(function(error) { console.log(error) })
      this.dialogStatus = 'addRule'
    },
    /* 编辑 */
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.dialogStatus = 'editRule'
      let params = {
        ruleId: row.ruleId
      }
      let _self = this
      this.$axios
        .get(this.$API.warning.queryAlarmRuleById, { params: params })
        // .get('http://172.16.9.104:5010/agw/alarmRuleCtr/queryAlarmRuleById', { params: params })
        .then(function (r) {
          let data = r.data.resData
          console.log(data)
          /* 取出预警对象id集合 */
          let alarmobjectIds = []
          let appData = data.appKeyObjectRefList
          let obj = {}
          obj.sysId = data.sysId
          obj.appKey = data.appKeyList
          _self.queryAlermType(data.sysId)
          _self.$axios
            .post(_self.$API.warning.queryAllAlarmObject, obj)
            // .post('http://172.16.9.104:5010/agw/alarmObjectCtr/queryAlarmObjectListById', obj)
            .then(function (r) {
              _self.alarmobjectData = r.data.resData.alarmObjectList
              appData.forEach(item => {
                for (let v of _self.alarmobjectData) {
                  if (item.appKey === v.appKey && item.objectIds === v.objectId) {
                    alarmobjectIds.push(v.refId)
                  }
                }
                // if (item.objectIds && item.appKey) {
                //   let objId = item.objectIds.split(',')
                //   for (let v of _self.alarmobjectData) {
                //     for (let o of objId) {
                //       if (o === v.objectId && v.appKey === item.appKey) {
                //         alarmobjectIds.push(v.refId)
                //       }
                //     }
                //   }
                // }
              })
              _self.ruleForm.alarmobjectIds = alarmobjectIds
              console.log(_self.ruleForm.alarmobjectIds)
            })
            .catch(function (error) { console.log(error) })
          // 根据选中模板id返回模板描述
          // let alarmDesc = ''
          // let templateData = _self.templateData
          // for (let i = 0; i < templateData.length; i++) {
          //   if (data.templateId === templateData[i].templateId) {
          //     alarmDesc = templateData[i].templateContent
          //   }
          // }
          // 根据是否循环判断发送次数和间隔时间是否禁选
          data.cycleFlag === '1'
            ? (_self.ruleInputDisabled = false)
            : (_self.ruleInputDisabled = true)
          _self.ruleForm = {
            ruleId: data.ruleId, // 规则id
            ruleName: data.ruleName, // 规则名称
            sysId: Number(data.sysId), // 系统id
            ruleEnName: data.ruleEnName, // 规则英文名称
            alarmType: data.alarmType, // 预警类型(0:余额不足预警)
            ruleState: parseInt(data.ruleState), // 规则状态(0:正常 1:停止 2:测试)
            alarmChannel: data.alarmChannel.split(','), // 预警渠道(0:短信)
            alarmTime: data.alarmTime,
            appKey: data.appKeyList,
            cycleFlag: data.cycleFlag, // 是否循环(0否1是)
            cycleCount: data.cycleCount === 0 ? '' : data.cycleCount, // 循环发送次数
            cycleInterval: data.cycleInterval === 0 ? '' : data.cycleInterval, // 循环时间间隔
            alarmobjectIds: alarmobjectIds, // 预警对象id集合
            templateId: data.templateId, // 模板id
            ruleDesc: data.ruleDesc, // 规则描述
            signName: data.signName,
            date: data.alarmDate ? data.alarmDate.split(',') : [],
            startTime: '',
            alarmContent: data.alarmContent
          }
          if (data.alarmDate) {
            _self.ruleForm.date = data.alarmDate.split(',')
            console.log(_self.ruleForm.date)
          }
          console.log(_self.ruleForm.date)
          if (data.alarmStart) {
            _self.ruleForm.startTime = []
            _self.ruleForm.startTime.push(data.alarmStart)
            _self.ruleForm.startTime.push(data.alarmEnd)
          }
          let op = {}
          op.appOwner = 1
          _self.$http
            .post(_self.$API.pay.queryAllAppInfo, {}, { headers: op })
            .then(function(r) {
              console.log(r)
              _self.appKeyList = r.data.resData
            })
            .catch(function(error) { console.log(error) })
        })
        .catch(function (error) {})
    },
    /* 根据状态保存新增/编辑预警规则 */
    saveRule (formName) {
      let appKeyObjectRefList = []
      console.log(this.ruleForm.alarmobjectIds)
      console.log(this.alarmobjectData)
      for (let v of this.alarmobjectData) {
        for (let o of this.ruleForm.alarmobjectIds) {
          let list = {}
          if (v.refId === o) {
            list.objectIds = v.objectId
            list.appKey = v.appKey
            appKeyObjectRefList.push(list)
          }
        }
      }
      if (this.dialogStatus == 'editRule') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let sysIds = []
            if (this.ruleForm.sysId) {
              sysIds.push(this.ruleForm.sysId)
            }
            let alarmDate = ''
            if (this.ruleForm.date.length) {
              alarmDate = this.ruleForm.date.join(',')
            }
            let params = {
              alarmChannel: this.ruleForm.alarmChannel
              ? this.ruleForm.alarmChannel.join(',')
              : '',
              sysIds: sysIds,
              alarmDate: alarmDate,
              alarmStart: this.ruleForm.startTime ? this.ruleForm.startTime[0]  : '',
              alarmEnd: this.ruleForm.startTime ? this.ruleForm.startTime[1]  : '',
              alarmTime: this.ruleForm.alarmTime,
              alarmType: this.ruleForm.alarmType,
              // alarmobjectIds: this.ruleForm.alarmobjectIds
              // ? this.ruleForm.alarmobjectIds.join(',')
              // : '',
              cycleCount: this.ruleForm.cycleCount ? parseInt(this.ruleForm.cycleCount) : 0,
              cycleFlag: this.ruleForm.cycleFlag,
              cycleInterval: this.ruleForm.cycleInterval ? parseInt(this.ruleForm.cycleInterval) : 0,
              ruleDesc: this.ruleForm.ruleDesc,
              ruleEnName: this.ruleForm.ruleEnName,
              ruleId: this.ruleForm.ruleId,
              ruleName: this.ruleForm.ruleName,
              ruleState: this.ruleForm.ruleState + '',
              signName: this.ruleForm.signName,
              appKeyList: this.ruleForm.appKey,
              appKeyObjectRefList: appKeyObjectRefList,
              alarmContent: this.ruleForm.alarmDesc,
              templateId: this.ruleForm.templateId
            }
            console.log(this.ruleForm.cycleFlag)
            if (this.ruleForm.cycleFlag === '1') {
              console.log('2019-01-01 ' + this.ruleForm.startTime[0])
              let alarmStart = new Date('2019-01-01 ' + this.ruleForm.startTime[0])
              let alarmEnd = new Date('2019-01-01 ' + this.ruleForm.startTime[1])
              let diff = alarmEnd - alarmStart
              console.log(diff)
              let time = (Number(this.ruleForm.cycleCount) * Number(this.ruleForm.cycleInterval))
              if (diff < time) {
                this.$message({
                  type: 'error',
                  message: '预警时间要大于循环间隔时间'
                })
                return
              }
            }
            this.$axios
              .post(this.$API.warning.updateAlarmRule, params)
              // .post('http://172.16.9.104:5010/agw/alarmRuleCtr/updateAlarmRule', params)
              .then(function (r) {
                _self.dialogFormVisible = false
                _self.$message({
                  type: 'success',
                  message: '保存成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          }
        })
      } else if (this.dialogStatus == 'addRule') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let sysIds = []
            if (this.ruleForm.sysId) {
              sysIds.push(this.ruleForm.sysId)
            }
            let alarmDate = ''
            if (this.ruleForm.date.length) {
              alarmDate = this.ruleForm.date.join(',')
            }
            // let alarmobjectIds = []
            // for (let v of appKeyObjectRefList) { // 将appkey转化为objectId
            //   alarmobjectIds.push(v.objectIds)
            // }
            console.log(appKeyObjectRefList)
            let params = {
              ruleName: this.ruleForm.ruleName,
              ruleEnName: this.ruleForm.ruleEnName,
              sysIds: sysIds,
              alarmDate: alarmDate,
              alarmStart: this.ruleForm.startTime ? this.ruleForm.startTime[0]  : '',
              alarmEnd: this.ruleForm.startTime ? this.ruleForm.startTime[1]  : '',
              alarmType: this.ruleForm.alarmType,
              ruleState: this.ruleForm.ruleState,
              alarmChannel: this.ruleForm.alarmChannel
                ? this.ruleForm.alarmChannel.join(',')
                : '', // 数组拆成字符串
              alarmTime: this.ruleForm.alarmTime,
              cycleFlag: this.ruleForm.cycleFlag,
              cycleCount: this.ruleForm.cycleCount,
              cycleInterval: this.ruleForm.cycleInterval,
              // alarmobjectIds: this.ruleForm.alarmobjectIds
              //   ? this.ruleForm.alarmobjectIds.join(',')
              //   : '', // 数组拆成字符串
              templateId: this.ruleForm.templateId,
              appKeyList: this.ruleForm.appKey,
              appKeyObjectRefList: appKeyObjectRefList,
              ruleDesc: this.ruleForm.ruleDesc
            }
            if (this.ruleForm.cycleFlag === '1') {
              let alarmStart = new Date('2019-01-01 ' + this.ruleForm.startTime[0])
              let alarmEnd = new Date('2019-01-01 ' + this.ruleForm.startTime[1])
              let diff = alarmEnd - alarmStart
              console.log(diff)
              let time = (Number(this.ruleForm.cycleCount) * Number(this.ruleForm.cycleInterval))
              if (diff < time) {
                this.$message({
                  type: 'error',
                  message: '预警时间要大于循环间隔时间'
                })
                return
              }
            }
            this.$axios
              .post(this.$API.warning.addAlarmRule, params)
              // .post('http://172.16.9.104:5010/agw/alarmRuleCtr/addAlarmRule', params)
              .then(function (r) {
                _self.dialogFormVisible = false
                _self.$message({
                  type: 'success',
                  message: '保存成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          }
        })
      }
    },
    /* 删除 */
    handleDelete (index, row) {
      let params = {
        ruleId: row.ruleId
      }
      this.$confirm('确认是否删除此预警规则？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let _self = this
          this.$axios
            .get(this.$API.warning.deleteAlarmRule, { params: params })
            .then(function (r) {
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryList()
            })
            .catch(function (error) {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    /* 查询 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 关闭弹窗 */
    closeDialog (formName) {
      this.dialogFormVisible = false
      /* 关闭对话框清除验证和表单内容 */
      this.$refs[formName].resetFields()
      this.ruleInputDisabled = true
      this.alarmobjectData = []
      this.ruleForm = {
        ruleId: '', // 规则id
        sysId: '',
        date: [],
        startTime: '',
        ruleName: '', // 规则名称
        ruleEnName: '', // 规则英文名称
        alarmType: '', // 预警类型(0:余额不足预警)
        ruleState: '', // 规则状态(0:正常 1:停止 2:测试)
        alarmChannel: [], // 预警渠道(0:短信)
        alarmTime: '',
        appKey: [],
        cycleFlag: '0', // 是否循环(0否1是)
        cycleCount: '', // 循环发送次数
        cycleInterval: '', // 循环时间间隔
        alarmobjectIds: [], // 预警对象id集合
        templateId: '', // 模板id
        ruleDesc: '', // 规则描述
        alarmDesc: '' // 存放预警内容描述
      }
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.size = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/warning/ruleManagement.js